export const toast = (msg: string) => {
  window.M.toast({ 
    html: msg,
    displayLength: 2000 
  })
}